import { withLogs } from '@core';

import { apiClient, ApiConfig } from '../apiClient';

import { Swing } from './swing';

export type ActivitySwing = Swing & { number: number };

const mapActivitySwings = (data: Swing[]): ActivitySwing[] => {
    // TODO: swing number should come from the data source, not calculated on the client.
    // Reason for that is sometimes we want to get a swing number in activity when querying
    // an individual swing.
    return (
        data
            .sort((a: Swing, b: Swing) => {
                // we want swings in order, so we could calculate the swing number by `createdAt`
                return new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime();
            })
            .map((s, idx) => {
                return {
                    ...s,
                    number: idx + 1,
                };
            })
            // we reverse since in activity context we prepend new values, not append
            // this should be reviewed when slimming down activity context.
            .reverse()
    );
};

export const fetchActivitySwings = withLogs(async (activityId: number): Promise<ActivitySwing[]> => {
    const { data } = await apiClient.get<Swing[]>(ApiConfig.path(`/api/v1/activities/${activityId}/swings`));

    return mapActivitySwings(data);
}, 'fetchActivitySwings');
